import React, { Component } from 'react';
import axios from "axios";
export function transferDate(dateString,type){
    if(!dateString){
        return ''
    }
    var year = new Date(dateString).getFullYear();
    var month = new Date(dateString).getMonth()+1;
    var day = new Date(dateString).getDate();
    var hour = new Date(dateString).getHours();
    var minute = new Date(dateString).getMinutes();
    var second = new Date(dateString).getSeconds();
    if(isNaN(year)||isNaN(month)||isNaN(day)||isNaN(hour)||isNaN(minute)||isNaN(second)){
        return historyLogLang.template("P_YS_PF_GZTPRE_0000071075") /* "未知日期" */
        // return <FormattedMessage id="unknowData"/>
    }
    // return `${year}年${month}月${day}日${hour}时${minute}分${second}秒`
    if(type){
      function prefixInteger(num) {
        return ('0000'+ num).slice(-2);
      }
      return `${year}-${prefixInteger(month)}-${prefixInteger(day)} ${prefixInteger(hour)}:${prefixInteger(minute)}:${prefixInteger(second)}`
    }
}


export function requestGet(url,option={}){
    var data = option
    var url = url
    var paramArr = []
    for(let k in data){
      paramArr.push([k,data[k]]);
    }
    // fix: edge 浏览器报错:接口返回格式不是application/json格式
    // var param = new URLSearchParams(paramArr).toString();
  var param = paramArr.reduce((item, value, key) => {
    let tmp = value[0] + "=" + value[1] + (key < paramArr.length - 1 ? "&" : "")
    item = item + tmp
    return item
  }, '');
    if(param.length>0){
        if(url.indexOf('?')>=0){
            url = url +'&' + param
        }else{
            url = url + '?' + param
        }
    }
    var option = {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'include', // include, same-origin, *omit
      withCredentials: true,
      headers: {
        'content-type': 'application/json'
      },
      mode: 'cors', // no-cors, cors, *same-origin
    }
    return axios(url, option)
        .then(data => {
            return data.data
        })
        .catch(error => console.error(error))
  }



// WEBPACK FOOTER //
// ./src/components/helper/helper.js